import AppHeader from '../AppHeader'
import DayJs from 'dayjs'

export default {
  name: 'company_notice_new',
  components: {
    AppHeader
  },
  data () {
    return {
      notice_title: '',
      notice_content: '',
      notice_start_date: '',
      notice_end_date: '',
      is_mail_delivery: true,
      savingFlag: false
    }
  },
  computed: {
    startDate () {
      return DayJs(this.notice_start_date).format('YYYY-MM-DD')
    },
    endDate () {
      return DayJs(this.notice_end_date).format('YYYY-MM-DD')
    },
    validation () {
      const validation = {
        notice_title: !!this.notice_title,
        notice_content: !!this.notice_content,
        notice_start_date: !!this.notice_start_date
      }
      return validation
    },
    validationAll () {
      if (!this.validation.notice_title) return false
      if (!this.validation.notice_content) return false
      if (!this.validation.notice_start_date) return false
      if (this.validationNoticeStartDate) return false
      if (this.validationNoticeEndDate) return false
      return true
    },
    validationNoticeStartDate () {
      const today = DayJs(new Date()).format('YYYY-MM-DD')
      if (!DayJs(today).isBefore(this.startDate)) {
        return '明日以降の日付を選択してください。'
      }
    },
    validationNoticeEndDate () {
      // 通達表示開始日の後のみ登録可能とするので入力チェックも
      // 通達表示開始日が入力されているときのみ実施する
      if (!this.validation.notice_start_date) return

      const today = DayJs(new Date()).format('YYYY-MM-DD')
      if (!this.notice_end_date) {
        return '必須項目です。'
      }
      if (!DayJs(today).isBefore(this.endDate)) {
        return '明日以降の日付を選択してください。'
      }
      if (!(this.startDate < this.endDate)) {
        return '通知期間終了日は通達表示開始日より後の日付を入力してください。'
      }
    }
  },
  methods: {
    async onClickSave () {
      // 保存時連打対策
      if (this.savingFlag) return false
      this.savingFlag = true

      // 保存処理
      await this.$store.dispatch('CREATE_COMPANY_NOTICE', {
        data: {
          notice_title: this.notice_title,
          notice_content: this.notice_content,
          notice_start_date: this.startDate,
          notice_end_date: this.endDate,
          is_mail_delivery: (this.is_mail_delivery) ? 1 : 0
        }
      })
      .catch(err => {
        console.error(err)
        return
      })
      this.$router.push('/company_notice_list')
    },
    onClickCancel () {
      this.$router.push('/company_notice_list')
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/company-notice-new.js